(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lbt-quote-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeForms = () => {
      const params = new URLSearchParams(window.location.search);
      const key = params.get('request');
      const types = { samples: 'Sample request', quote: 'Wholesale quotation', custom: 'Custom design' };
      const campaign = {};
      ['utm_source','utm_medium','utm_campaign','utm_content'].forEach((name) => {
        const value = params.get(name);
        if (value && /^[a-zA-Z0-9._-]{1,100}$/.test(value)) campaign[name] = value;
      });
      document.querySelectorAll('a[href]').forEach((link) => {
        const url = new URL(link.href, window.location.href);
        if (url.origin !== window.location.origin || url.pathname !== '/pages/contact-us') return;
        Object.entries(campaign).forEach(([name,value]) => url.searchParams.set(name,value));
        link.href = url.pathname + url.search + url.hash;
      });
      document.querySelectorAll('.lbt-quote-form').forEach((form) => {
        if (form.dataset.lbtReady) return;
        form.dataset.lbtReady = 'true';
        const request = form.querySelector('[data-lbt-request-type]');
        if (!request) return;
        if (!request.value && Object.prototype.hasOwnProperty.call(types, key)) request.value = types[key];
        const model = form.querySelector('[data-lbt-model]');
        form.querySelectorAll('[data-lbt-campaign]').forEach((input) => {
          if (!input.value) input.value = campaign[input.dataset.lbtCampaign] || '';
        });
        const code = params.get('model') || model.dataset.contextModel;
        if (!model.value && ['GH','GV','SH','SV'].includes(code)) model.value = code;
        const fields = Array.from(form.querySelectorAll('[data-lbt-letter]'));
        const unit = form.querySelector('[data-lbt-unit]');
        const output = form.querySelector('[data-lbt-total]');
        const summarize = () => {
          let count = 0;
          const lines = [];
          fields.forEach((input) => {
            const value = Number(input.value);
            if (Number.isSafeInteger(value) && value > 0 && value <= 10000000) {
              count += value;
              lines.push(input.dataset.lbtLetter + ': ' + value);
            }
          });
          const bags = unit.value === 'Bags of 20 pieces';
          const summary = bags ? `${count} ${output.dataset.bags} = ${count * 20} ${output.dataset.pieces}` : `${count} ${output.dataset.pieces}`;
          output.textContent = summary;
          form.querySelector('[data-lbt-summary]').value = lines.length ? `${lines.join('; ')}. Unit: ${unit.value}. Total: ${summary}` : '';
        };
        fields.forEach((input) => input.addEventListener('input', summarize));
        unit.addEventListener('change', summarize);
        form.addEventListener('submit', () => {
          summarize();
          const body = form.querySelector('textarea[name="contact[body]"]');
          if (!body.value.trim()) body.value = `${request.value}. Model: ${model.value}. ${form.querySelector('[data-lbt-summary]').value}`;
        });
        summarize();
        if (fields.some((input) => Number(input.value) > 0)) form.querySelector('details').open = true;
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeForms, { once: true });
    else initializeForms();
    document.addEventListener('shopify:section:load', initializeForms);
  })();
  } catch(e) { console.error(e); }
})();

})();
